// extracted by mini-css-extract-plugin
module.exports = {"container":"ImageBlock_container__2Ykh0","image":"ImageBlock_image__B0orM"};